interface PaymentIntent {
  id: string
  order_id: string
  subtotal: Price
  discount: Price
  total: Price
  net: Price
  participant_fee: Price
  type: string
  expires_at: string
  billing: null | BillingInfo
  payment_method: null | 'CC' | 'MBW' | 'MB' | 'Apple' | 'Google'
  payment_gateway: null | string
  status: PaymentIntentStatus
  use_connect: boolean
}
// TODO: payment_method should be an enum

export enum PaymentIntentStatus {
  pending = 'pending payment',
  processing = 'processing payment',
  finished = 'finished',
  expired = 'expired',
  cancelled = 'cancelled',
  rejected = 'rejected',
  refunded = 'refunded',
}

export enum LineItemType {
  ticket = 'ticket',
  addon = 'addon',
}

interface LineItem {
  id: string
  type: LineItemType
  amounts: {
    amount: number
    modified: number
    modifiers: null | Coupon[]
  }
  product: {
    ticket: Ticket
  }
  attributes: {
    seats: Seat[]
  }
}

interface Price {
  amount: number
  currency: string
}
